import { ReactComponent as Icon } from "components/icons/PlusIconCircle.svg";

export const PlusIcon = (): JSX.Element => {
  return (
    <Icon className="PlusIcon" />
  );
};
